import { clsx } from "clsx"

// Simple className merger without tailwind-merge to avoid React 17 compatibility issues
export function cn(...inputs) {
  return clsx(inputs)
}
